var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShareLogo = function SvgShareLogo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE1D23",
    fillRule: "evenodd",
    d: "M8.88 3.37a.3.3 0 0 0 .122-.252L9 3a3.001 3.001 0 0 1 6 0 3.001 3.001 0 0 1-4.951 2.278.29.29 0 0 0-.366-.017c-.564.407-2.189 1.588-2.649 1.922a.23.23 0 0 0-.09.234 3.1 3.1 0 0 1-.001 1.166.23.23 0 0 0 .091.234l2.648 1.924a.295.295 0 0 0 .368-.018A2.98 2.98 0 0 1 12 10a3.001 3.001 0 0 1 0 6 3 3 0 0 1-2.998-3.118.3.3 0 0 0-.122-.251l-2.896-2.105a.315.315 0 0 0-.358-.007A2.97 2.97 0 0 1 4 11a3.001 3.001 0 0 1 0-6c.599 0 1.158.176 1.627.48.108.072.25.069.355-.007.58-.419 2.392-1.736 2.898-2.103",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShareLogo);
export default ForwardRef;